<template>
    <div class="container-fluid">
        <div class="titlle_div">
            <h5 class="title">Días no hábiles</h5>
        </div>
        <emt-form ref="date-form" v-bind:resource="config.api + '/date_not_available/'" v-bind:items="itemsForm" v-on:register="reload" v-bind:updateData="update"></emt-form>
        <emt-grid ref="date-grid" v-bind:resource="config.api + '/date_not_available/'" v-bind:items="itemsGrid" v-bind:edit="editUrl" v-bind:deleteUrl="deleteUrl" v-bind:btnEdit="btnEdit" v-bind:btnDelete="btnDelete"></emt-grid>
    </div>
</template>

<script>
import Cookies from 'js-cookie'
import router from '@/router'
import generic from '@/generic'
import Config from '@/config'
import EmtForm from '@/components/emt-form'
import EmtLoading from '@/components/emt-loading'
import EmtTable from '@/components/emt-grid'

export default{
    name: 'emt-form-date-not-available',
    data: function () {
        return {
            itemsForm: [
                {
                    'name': 'date',
                    'label': 'Fecha',
                    'class': 'form-control txb-calendar',
                    'divclass': 'col-md-3',
                    'placeholder': 'Ingrese fecha',
                    'value': null,
                    'maxlength': '50',
                    'type': 'date',
                    'disabled': {
                        'to': new Date()
                    },
                    'errors': []
                }
            ],
            itemsGrid: [
                {
                    'name': 'date',
                    'label': 'Fecha',
                    'ordering': true,
                    'filters': ['exact']
                }
            ],
            config: Config,
            update: false,
            editUrl: '/DateNotAvailable/',
            deleteUrl: Config.api + '/date_not_available/',
            btnEdit: false,
            btnDelete: false
        }
    },
    methods: {
        reload: function () {
            this.$refs['date-grid'].reload()
        }
    },
    created: function () {
        if (!Cookies.get('token')) {
            router.push('/login')
            return
        }
        generic.setToken()
    },
    components: {
        'emt-form': EmtForm,
        'emt-loading': EmtLoading,
        'emt-grid': EmtTable
    }
}
</script>



// WEBPACK FOOTER //
// emt-form-date-not-available.vue?00ea2610